var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, CloseEventListener, OpenEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class SlidebarAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
        /** @event */
        this.onOpen = new OpenEventListener();
    }
    /**
     * Closes the slidebar triggering the `onClose` event.
     */
    close() {
        if (!this.isOpen()) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.setState({ open: false });
            this.onClose.fire();
        }
    }
    /**
     * Opens the slidebar triggering the `onOpen` event.
     */
    open() {
        if (this.isOpen()) {
            return;
        }
        this.setState({ open: true });
        this.onOpen.fire();
    }
    /**
     * Checks if the slidebar is configured to close on clicking outside it.
     */
    isCloseByDocument() {
        return this.state.closeByDocument;
    }
    /**
     * Sets if the slidebar should close on clicking outside it.
     *
     * @param closeByDocument - if the slidebar should close.
     */
    setCloseByDocument(closeByDocument) {
        this.setState({ closeByDocument });
    }
    /**
     * Checks if the slidebar is configured to close on pressing the escape key.
     */
    isCloseByEscape() {
        return this.state.closeByEscape;
    }
    /**
     * Sets if the slidebar should close on pressing the escape key.
     *
     * @param closeByEscape - if the slidebar should close.
     */
    setCloseByEscape(closeByEscape) {
        this.setState({ closeByEscape });
    }
    /**
     * Checks if the slidebar is open.
     */
    isOpen() {
        return this.state.open;
    }
    /**
     * Sets if the slidebar header should be hidden.
     *
     * @param hideHeader - if the slidebar header should be hidden.
     */
    setHideHeader(hideHeader) {
        this.setState({ hideHeader });
    }
    /**
     * Checks if the slidebar header is hidden.
     */
    isHeaderHidden() {
        return this.state.hideHeader;
    }
    /**
     * Sets if the slidebar close button should be visible.
     *
     * @param showCloseButton - if the slidebar close button should be visible.
     */
    setShowCloseButton(showCloseButton) {
        this.setState({ showCloseButton });
    }
    /**
     * Checks if the slidebar close button is visible.
     */
    isShowCloseButton() {
        return this.state.showCloseButton;
    }
    /**
     * Sets if the slidebar should open.
     *
     * @param open - if the slidebar should open.
     */
    setOpen(open) {
        this.setState({ open });
    }
    /**
     * Gets the current slidebar title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the title of the slidebar.
     *
     * @param title - the new title.
     */
    setTitle(title) {
        this.setState({ title });
    }
    /**
     * Checks if the overlay is transparent.
     */
    hasTransparentOverlay() {
        return Boolean(this.state.transparentOverlay);
    }
    /**
     * Sets if the slidebar overlay should be transparent.
     *
     * @param transparentOverlay - if the overlay should be transparent.
     */
    setTransparentOverlay(transparentOverlay) {
        this.setState({ transparentOverlay });
    }
    /**
     * Gets the current placement of the slidebar.
     */
    getPlacement() {
        return this.state.placement;
    }
    /**
     * Sets the placement of the slidebar.
     *
     * @param placement - the new placement.
     */
    setPlacement(placement) {
        this.setState({ placement });
    }
    /**
     * Gets the current slidebar theme.
     */
    getTheme() {
        return this.state.theme;
    }
    /**
     * Sets the theme of the slidebar
     *
     * @param theme - the new theme.
     */
    setTheme(theme) {
        this.setState({ theme });
    }
    /**
     * Gets the current slidebar offset.
     */
    getOffset() {
        return this.state.offset ?? 0;
    }
    /**
     * Sets the offset of the slidebar
     *
     * @param offset - the new offset.
     */
    setOffset(offset) {
        this.setState({ offset });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SlidebarAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SlidebarAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SlidebarAPI.prototype, "onOpen", void 0);
export { SlidebarAPI, };
//# sourceMappingURL=slidebar-api.js.map